import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const LinkElement = styled.a`
  display: block;
  width: 32px;
  height: 32px;

  background-size: 32px 32px;
  opacity: 0.5;
  pointer-events: auto;
  cursor: pointer;

  ${({ type }) => (
    `background-image: url('${process.env.PUBLIC_URL}/share-${type}.svg');`
  )}

  &:hover {
    opacity: 1;
  }
`;

const generateUrl = (service) => {
  switch (service) {
    case 'facebook':
      return 'https://www.facebook.com/sharer/sharer.php?u=';

    case 'linkedin':
      return 'https://www.linkedin.com/shareArticle?url=';

    case 'twitter':
      return 'https://twitter.com/intent/tweet?url=';

    default:
      return null;
  }
};

/**
 * Footer element
 */
export default class SharingLink extends React.PureComponent {
  static propTypes = {
    type: PropTypes.string.isRequired,
  };

  /**
   * Constructor
   * @param {!props} props
   */
  constructor(props) {
    super(props);

    this.openLink = this.openLink.bind(this);
  }

  /**
   * Open the share link
   */
  openLink() {
    const { type } = this.props;
    const url = generateUrl(type);

    if (url) {
      window.open(
          `${url}${encodeURIComponent(window.location.href)}`,
          'share',
          'width=600,height=400',
      );
    }
  }

  /**
   * React lifecycle method
   * @param {*} object
   * @return {JSX}
   */
  render() {
    const { type } = this.props;

    return (
      <LinkElement onClick={this.openLink} type={type} />
    );
  }
}
